module.exports = __webpack_public_path__ + "img/internal-report.9a49d45e.svg";